import { combineReducers } from 'redux';
import locale from '@/redux/locale.slice';

export default combineReducers({
  locale,
});
